import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconImageSearch } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { Gallery } from '../../components/ImageGalleryPreview/components/Gallery.js';
import { useImageGalleryPreview } from '../../components/ImageGalleryPreview/useImageGalleryPreview.js';
import { ImageGrid } from '../../components/ImageGrid/index.js';
export const ImageGalleryPreview = ({
  images,
  onClickImage
}) => {
  const {
    t
  } = useTranslation('travelDetailsOverlay');
  const gallery = useImageGalleryPreview({
    images
  });
  return _jsx(Gallery, {
    layout: gallery.layout,
    children: gallery.images.map((image, index) => {
      const shouldDisplayAdditionalImages = index === gallery.images.length - 1 && images.length > gallery.images.length;
      return _jsxs(ImageGrid.Item, {
        children: [image.src && _jsx(ImageGrid.ImageButton, {
          image: _jsx(ImageGrid.Image, {
            src: image.src,
            alt: image.alt
          }),
          dimmed: shouldDisplayAdditionalImages,
          onClick: () => onClickImage({
            index,
            galleryItemCount: gallery.images.length
          }),
          children: shouldDisplayAdditionalImages && _jsxs(_Fragment, {
            children: [t('tourOperatorImages.allImagesButton', {
              imageCount: images.length
            }), _jsx(IconImageSearch, {})]
          })
        }), !image.src && _jsx(ImageGrid.ImageFallback, {})]
      }, index);
    })
  });
};